export function subMenus() {
  document.addEventListener("DOMContentLoaded", (event) => {
    const topLevelLinks = document.querySelectorAll(
      ".menu-item.has-submenu button"
    );
    const header = document.querySelector("header");
    const body = document.body;

    function isSubMenuOpen() {
      return [...document.querySelectorAll(".submenu")].some((subMenu) =>
        subMenu.classList.contains("open")
      );
    }

    function isFeatureExplanationsOpen() {
      const panel = document.getElementById("explanations");
      return panel && panel.classList.contains("active");
    }

    function removeMenuOverlay() {
      if (!isFeatureExplanationsOpen()) {
        body.classList.remove("add-overlay");
      }
    }

    function closeAllSubMenus() {
      topLevelLinks.forEach((link) => {
        const dataText = link.getAttribute("data-text");
        const subMenu = document.querySelector(
          `.submenu[data-text="${dataText}"]`
        );
        const menuItem = link.closest(".menu-item");

        if (subMenu.classList.contains("open")) {
          subMenu.classList.remove("open");
          menuItem.classList.remove("clicked");
        }
      });
    }

    topLevelLinks.forEach((topLevelLink) => {
      topLevelLink.addEventListener("click", function () {
        const dataText = topLevelLink.getAttribute("data-text");
        const subMenu = document.querySelector(
          `.submenu[data-text="${dataText}"]`
        );

        if (subMenu) {
          if (subMenu.classList.contains("open")) {
            subMenu.classList.remove("open");
            topLevelLink.closest(".menu-item").classList.remove("clicked");
            header.classList.remove("dark");
            removeMenuOverlay();
          } else {
            closeAllSubMenus();

            subMenu.classList.add("open");
            topLevelLink.closest(".menu-item").classList.add("clicked");
            header.classList.add("dark");
            body.classList.add("add-overlay");
          }
        }
      });
    });

    window.addEventListener("scroll", function () {
      if (window.scrollY > 10) {
        header.classList.add("header-translate");

        if (isSubMenuOpen()) {
          closeAllSubMenus();
          header.classList.remove("dark");
          removeMenuOverlay();
        }
      }
    });

    const subMenus = document.querySelectorAll(".submenu");

    body.addEventListener("click", function (event) {
      if (!isSubMenuOpen()) return;

      const explanationsPanel = document.getElementById("explanations");
      if (explanationsPanel && explanationsPanel.contains(event.target)) return;

      let isClickOutsideSubMenus = true;

      subMenus.forEach(function (subMenu) {
        if (subMenu.contains(event.target)) {
          isClickOutsideSubMenus = false;
        }
      });

      if (!header.contains(event.target) && isClickOutsideSubMenus) {
        closeAllSubMenus();
        header.classList.remove("dark");
        removeMenuOverlay();
      }
    });
  });

  // Main menu images

  document.addEventListener("DOMContentLoaded", function () {
    const menuImageElements = document.querySelectorAll(".menu-item-image");

    menuImageElements.forEach((img, index) => {
      if (index === 0) {
        img.classList.add("active");
      } else {
        img.classList.remove("active");
      }
    });

    const menuItems = [...menuImageElements].map((image) => image.parentNode);

    menuItems.forEach(function (item) {
      item.addEventListener("mouseover", function () {
        // Hide all images and remove 'active' class
        menuImageElements.forEach((img) => {
          img.classList.add("invisible", "opacity-0");
          img.classList.remove("active");
        });

        // Add 'active' class to the hovered image
        const img = item.querySelector(".menu-item-image");
        if (img) {
          img.classList.remove("invisible", "opacity-0");
          img.classList.add("active");
        }
      });
    });
  });
}
